module.exports = __webpack_public_path__ + "static/img/send.1fb48fbb.svg";